export enum CourseNotificationViewingStatus {
    UNSEEN,
    SEEN,
    ARCHIVED,
}
